/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Locale} from '../models/Locale';

export interface GetAccountDefaultLocale$Request {
    accountId: number;
}

export interface GetAccountDefaultLocale$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountDefaultLocaleRequest = createAction<PayloadData<void, GetAccountDefaultLocale$Request>>('GET_ACCOUNT_DEFAULT_LOCALE__GET_ACCOUNT_DEFAULT_LOCALE__REQUEST');
export const getAccountDefaultLocaleSuccess = createAction<PayloadData<Locale, GetAccountDefaultLocale$Request>>('GET_ACCOUNT_DEFAULT_LOCALE__GET_ACCOUNT_DEFAULT_LOCALE__SUCCESS');
export const getAccountDefaultLocaleFailure = createAction<PayloadData<Error, GetAccountDefaultLocale$Request, true>>('GET_ACCOUNT_DEFAULT_LOCALE__GET_ACCOUNT_DEFAULT_LOCALE__FAILURE');

export const getAccountDefaultLocaleActions = [
    getAccountDefaultLocaleRequest,
    getAccountDefaultLocaleSuccess,
    getAccountDefaultLocaleFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountDefaultLocale = (meta: GetAccountDefaultLocale$Request, config?: GetAccountDefaultLocale$Config) => {
    return {
        CALL_API: {
            types: getAccountDefaultLocaleActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/default-locales`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

